import * as React from "react";
import { Product } from "../../../models";

export interface SuggestionItemProps {
  onClick: (e: any) => void;
  product: Product;
}

// TODO: the item is done in CSS via class; need to change this
const SuggestionItem = ({ product, onClick }: SuggestionItemProps) =>
  <li className="product-suggestions__item" onClick={onClick}>
    <div
      className="product-suggestions__item__icon"
      style={{
        backgroundImage: `url(${product.logo})`,
      }}
    />
    <p>
      {product.name}
    </p>
  </li>;

export default SuggestionItem;



// WEBPACK FOOTER //
// ./src/routes/ProductSearch/components/SuggestionItem.tsx